// @flow

import { onlyNumbers } from '@tectonics/prs/normalize';

const ENDS_WITH_K_REGEXP = /k$/ui;

export function normalizeCustomerDocument(documentValue: ?string): string {
  const numbers = documentValue ? onlyNumbers(documentValue) : '';
  const k = documentValue && ENDS_WITH_K_REGEXP.test(documentValue) ? 'K' : '';
  return numbers + k;
}
